// extracted by mini-css-extract-plugin
module.exports = {"container":"UM-z","hidden":"VM-z"};